// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../../../../types';

export default styled<any, Theme>('div')`
  pointer-events: none;
  background: linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)) 0 0 no-repeat rgba(0, 0, 0, 0.15);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: -3px; /* tile border */
  display: flex;
  align-items: center;
  justify-content: center;
`;
